import image1 from '../images/haker.jpg';
import tarasBogun from '../images/developers/taras_bogun.jpg';
import yulia from '../images/developers/yulia.jpg';
import evgeniy from '../images/developers/evgeniy.jpg';
import serhii from '../images/developers/serhii.jpg';
import shatohin from '../images/developers/shatohin.jpg';
import serhiiP from '../images/developers/serhii_p.jpg';
import svitlana from '../images/developers/svetlana.jpg';
import andreiv from '../images/developers/andreiv.jpg';
import dima from '../images/developers/dima.jpg';
import rostislav from '../images/developers/rostislav.jpg';
import roman from '../images/developers/roman.jpg';

export const developers = [
    {
      name: 'Serhii Prokip',
      text: 'Team lead. Footer, footer modal, Main and library modal function',
      img: serhiiP,
      linkedin: 'https://www.linkedin.com/in/serhii-prokip-422782250',
      github: 'https://github.com/iTSerhii85',
    },
    {
      name: 'Yulia Safonova',
      text: 'Scrum master. General styles',
      img: yulia,
      linkedin: '',
      github: 'https://github.com/Yulia-Safonova-85',
    },
    {
      name: 'Andrii Voznyi',
      text: 'Developer. Main gallery, fetch function',
      img: andreiv,
      linkedin: 'https://www.linkedin.com/in/andrii-voznyi-8a95a6264/',
      github: 'https://github.com/DWIJIx',
    },
    {
      name: 'Roman Korzun',
      text: 'Developer. Headers, up button, stiles',
      img: roman,
      linkedin: 'https://www.linkedin.com/in/roman-korzun/',
      github: 'https://github.com/romancarpangler',
    },
    {
      name: 'Andrew Shatohin',
      text: 'Developer. Library',
      img: shatohin,
      linkedin: 'https://www.linkedin.com/in/andrii-shatokhin-016672264/',
      github: 'https://github.com/Andrew-Shatokhin',
    },
    {
      name: 'Serhii',
      text: 'Developer. Dark mode.',
      img: serhii,
      linkedin: '#',
      github: 'https://github.com/Serj-Melnyk',
    },
    {
      name: 'Dmitriy',
      text: 'Developer. Main and library modal stiles.',
      img: dima,
      linkedin: 'https://www.linkedin.com/in/dmytro-novitskyi-576390264/',
      github: 'https://github.com/Dmytro1001',
    },
    {
      name: 'Taras Bohun',
      text: 'Developer. Headers and up button.',
      img: tarasBogun,
      linkedin: 'https://www.linkedin.com/in/taras-bohun-94ab28262/',
      github: 'https://github.com/TarasBohun',
    },
    {
      name: 'Svitlana',
      text: 'Developer. Main modal button function.',
      img: svitlana,
      linkedin: 'https://www.linkedin.com/in/%D1%81%D0%B2%D1%96%D1%82%D0%BB%D0%B0%D0%BD%D0%B0-%D1%88%D0%B2%D0%B8%D0%B4%D0%B0%D0%BD%D0%B5%D0%BD%D0%BA%D0%BE-0b027385/',
      github: 'https://github.com/Svitlana-Sh',
    },
    {
      name: 'Evgeniy',
      text: 'Developer. Pagination function.',
      img: evgeniy,
      linkedin: 'https://www.linkedin.com/in/%D1%94%D0%B2%D0%B3%D0%B5%D0%BD%D1%96%D0%B9-%D0%BA%D0%BB%D0%B8%D1%81%D0%B0%D0%BA-72a5978a/',
      github: 'https://github.com/Simon507?tab=repositories',
    },
    {
      name: 'Rostislav',
      text: 'Developer. Trailer show function.',
      img: rostislav,
      linkedin: 'https://www.linkedin.com/in/rostyslav-kryvovyaz/',
      github: 'https://github.com/RostyslavKr',
    }
  ];